import { render, staticRenderFns } from "./FeaturedSlider.vue?vue&type=template&id=0049da6c&"
import script from "./FeaturedSlider.vue?vue&type=script&lang=js&"
export * from "./FeaturedSlider.vue?vue&type=script&lang=js&"
import style1 from "./FeaturedSlider.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports